import { addToast } from '$lib/components/toaster/Toaster.svelte';
import { m as messages } from '$paraglide/messages';

let prompted = false;

// Shows a persistent toast offering to reload into the new build. Repeated
// calls while the prompt is already showing are ignored.
export function showReleasePrompt(): void {
  if (prompted) return;
  prompted = true;

  addToast({
    closeDelay: 0,
    data: {
      title: messages.newVersionAvailable(),
      action: { label: messages.refresh(), onClick: () => window.location.reload() },
    },
  });
}
